// @generated by protoc-gen-es v1.4.1 with parameter "target=ts+js+dts,import_extension=.mjs"
// @generated from file myid/api/myid.proto (package greyhole.myid, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum greyhole.myid.PhoneOTPMethod
 */
export const PhoneOTPMethod = proto3.makeEnum(
  "greyhole.myid.PhoneOTPMethod",
  [
    {no: 0, name: "PHONE_OTP_METHOD_UNSPECIFIED"},
    {no: 1, name: "SMS"},
    {no: 2, name: "VOICE"},
  ],
);

/**
 * @generated from enum greyhole.myid.Status
 */
export const Status = proto3.makeEnum(
  "greyhole.myid.Status",
  [
    {no: 0, name: "UNSPECIFIED"},
    {no: 1, name: "INACTIVE"},
    {no: 2, name: "ACTIVE"},
    {no: 3, name: "LOCKED"},
    {no: 4, name: "BANNED"},
    {no: 5, name: "INCOMPLETE"},
  ],
);

/**
 * @generated from enum greyhole.myid.StatusLogType
 */
export const StatusLogType = proto3.makeEnum(
  "greyhole.myid.StatusLogType",
  [
    {no: 0, name: "STATUS_LOG_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATUS_LOG_TYPE_LOCK", localName: "LOCK"},
    {no: 2, name: "STATUS_LOG_TYPE_BAN", localName: "BAN"},
    {no: 3, name: "STATUS_LOG_TYPE_UNLOCK", localName: "UNLOCK"},
    {no: 4, name: "STATUS_LOG_TYPE_UNBAN", localName: "UNBAN"},
  ],
);

/**
 * @generated from enum greyhole.myid.NetworkSymbol
 */
export const NetworkSymbol = proto3.makeEnum(
  "greyhole.myid.NetworkSymbol",
  [
    {no: 0, name: "NS_NONE"},
    {no: 1, name: "NS_BSC"},
    {no: 2, name: "NS_ETH"},
    {no: 3, name: "NS_TRX"},
    {no: 4, name: "NS_APT"},
    {no: 5, name: "NS_POLYGON"},
    {no: 6, name: "NS_AVAX"},
    {no: 7, name: "NS_ARB"},
    {no: 8, name: "NS_FTM"},
    {no: 9, name: "NS_CELO"},
  ],
);

/**
 * @generated from enum greyhole.myid.CryptoWalletProvider
 */
export const CryptoWalletProvider = proto3.makeEnum(
  "greyhole.myid.CryptoWalletProvider",
  [
    {no: 0, name: "WP_NONE"},
    {no: 1, name: "WP_METAMASK"},
    {no: 2, name: "WP_BINANCE_CHAIN_WALLET"},
    {no: 3, name: "WP_TRONLINK"},
    {no: 4, name: "WP_MARTIAN"},
    {no: 5, name: "WP_OMEGA"},
  ],
);

/**
 * @generated from enum greyhole.myid.UserType
 */
export const UserType = proto3.makeEnum(
  "greyhole.myid.UserType",
  [
    {no: 0, name: "USER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "USER_TYPE_OPERATOR", localName: "OPERATOR"},
    {no: 2, name: "USER_TYPE_AGENT", localName: "AGENT"},
    {no: 3, name: "USER_TYPE_PLAYER", localName: "PLAYER"},
  ],
);

/**
 * @generated from message greyhole.myid.SignUpRequest
 */
export const SignUpRequest = proto3.makeMessageType(
  "greyhole.myid.SignUpRequest",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "confirm_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "referrer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.SignUpV2Request
 */
export const SignUpV2Request = proto3.makeMessageType(
  "greyhole.myid.SignUpV2Request",
  () => [
    { no: 1, name: "my_id", kind: "message", T: SignUpV2Request_MyID, oneof: "credential" },
    { no: 2, name: "facebook", kind: "message", T: SignUpV2Request_Facebook, oneof: "credential" },
    { no: 6, name: "google", kind: "message", T: SignUpV2Request_Google, oneof: "credential" },
    { no: 7, name: "twitter", kind: "message", T: SignUpV2Request_Twitter, oneof: "credential" },
    { no: 8, name: "telegram", kind: "message", T: SignUpV2Request_Telegram, oneof: "credential" },
    { no: 9, name: "apple", kind: "message", T: SignUpV2Request_Apple, oneof: "credential" },
    { no: 3, name: "referrer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.SignUpV2Request.MyID
 */
export const SignUpV2Request_MyID = proto3.makeMessageType(
  "greyhole.myid.SignUpV2Request.MyID",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "confirm_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SignUpV2Request_MyID"},
);

/**
 * @generated from message greyhole.myid.SignUpV2Request.Facebook
 */
export const SignUpV2Request_Facebook = proto3.makeMessageType(
  "greyhole.myid.SignUpV2Request.Facebook",
  () => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SignUpV2Request_Facebook"},
);

/**
 * @generated from message greyhole.myid.SignUpV2Request.Google
 */
export const SignUpV2Request_Google = proto3.makeMessageType(
  "greyhole.myid.SignUpV2Request.Google",
  () => [
    { no: 1, name: "credential", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SignUpV2Request_Google"},
);

/**
 * @generated from message greyhole.myid.SignUpV2Request.Twitter
 */
export const SignUpV2Request_Twitter = proto3.makeMessageType(
  "greyhole.myid.SignUpV2Request.Twitter",
  () => [
    { no: 1, name: "oauth1", kind: "message", T: SignUpV2Request_Twitter_OAuth1, oneof: "version" },
    { no: 2, name: "oauth2", kind: "message", T: SignUpV2Request_Twitter_OAuth2, oneof: "version" },
  ],
  {localName: "SignUpV2Request_Twitter"},
);

/**
 * @generated from message greyhole.myid.SignUpV2Request.Twitter.OAuth1
 */
export const SignUpV2Request_Twitter_OAuth1 = proto3.makeMessageType(
  "greyhole.myid.SignUpV2Request.Twitter.OAuth1",
  () => [
    { no: 1, name: "oauth_verifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "oauth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SignUpV2Request_Twitter_OAuth1"},
);

/**
 * @generated from message greyhole.myid.SignUpV2Request.Twitter.OAuth2
 */
export const SignUpV2Request_Twitter_OAuth2 = proto3.makeMessageType(
  "greyhole.myid.SignUpV2Request.Twitter.OAuth2",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "code_verifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SignUpV2Request_Twitter_OAuth2"},
);

/**
 * @generated from message greyhole.myid.SignUpV2Request.Telegram
 */
export const SignUpV2Request_Telegram = proto3.makeMessageType(
  "greyhole.myid.SignUpV2Request.Telegram",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "auth_date", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "photo_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SignUpV2Request_Telegram"},
);

/**
 * @generated from message greyhole.myid.SignUpV2Request.Apple
 */
export const SignUpV2Request_Apple = proto3.makeMessageType(
  "greyhole.myid.SignUpV2Request.Apple",
  () => [
    { no: 1, name: "identity_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SignUpV2Request_Apple"},
);

/**
 * @generated from message greyhole.myid.SignUpReply
 */
export const SignUpReply = proto3.makeMessageType(
  "greyhole.myid.SignUpReply",
  () => [
    { no: 1, name: "token_info", kind: "message", T: TokenInfo },
  ],
);

/**
 * @generated from message greyhole.myid.SignUpOneClickRequest
 */
export const SignUpOneClickRequest = proto3.makeMessageType(
  "greyhole.myid.SignUpOneClickRequest",
  () => [
    { no: 1, name: "referrer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.SignUpOneClickReply
 */
export const SignUpOneClickReply = proto3.makeMessageType(
  "greyhole.myid.SignUpOneClickReply",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "token_info", kind: "message", T: TokenInfo },
  ],
);

/**
 * @generated from message greyhole.myid.SaveOneClickInfoRequest
 */
export const SaveOneClickInfoRequest = proto3.makeMessageType(
  "greyhole.myid.SaveOneClickInfoRequest",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "send_credential_to" },
    { no: 2, name: "phone_number", kind: "message", T: PhoneNumber, oneof: "send_credential_to" },
    { no: 10, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.SignUpPhoneRequest
 */
export const SignUpPhoneRequest = proto3.makeMessageType(
  "greyhole.myid.SignUpPhoneRequest",
  () => [
    { no: 1, name: "phone_number", kind: "message", T: PhoneNumber },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "confirm_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "referrer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.SignUpPhoneReply
 */
export const SignUpPhoneReply = proto3.makeMessageType(
  "greyhole.myid.SignUpPhoneReply",
  () => [
    { no: 1, name: "token_info", kind: "message", T: TokenInfo, oneof: "result" },
    { no: 2, name: "confirm_otp", kind: "message", T: OTP, oneof: "result" },
  ],
);

/**
 * @generated from message greyhole.myid.SignUpEmailRequest
 */
export const SignUpEmailRequest = proto3.makeMessageType(
  "greyhole.myid.SignUpEmailRequest",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "confirm_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "referrer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.SignUpEmailReply
 */
export const SignUpEmailReply = proto3.makeMessageType(
  "greyhole.myid.SignUpEmailReply",
  () => [
    { no: 1, name: "token_info", kind: "message", T: TokenInfo, oneof: "result" },
    { no: 2, name: "confirm_otp", kind: "message", T: OTP, oneof: "result" },
  ],
);

/**
 * @generated from message greyhole.myid.SignUpCryptoWalletRequest
 */
export const SignUpCryptoWalletRequest = proto3.makeMessageType(
  "greyhole.myid.SignUpCryptoWalletRequest",
  () => [
    { no: 1, name: "wallet_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "network_symbol", kind: "enum", T: proto3.getEnumType(NetworkSymbol) },
    { no: 3, name: "provider", kind: "enum", T: proto3.getEnumType(CryptoWalletProvider) },
    { no: 4, name: "public_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "referrer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.SignUpCryptoWalletReply
 */
export const SignUpCryptoWalletReply = proto3.makeMessageType(
  "greyhole.myid.SignUpCryptoWalletReply",
  () => [
    { no: 1, name: "token_info", kind: "message", T: TokenInfo },
    { no: 2, name: "challenge_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "nonce", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.ResendSignUpOTPRequest
 */
export const ResendSignUpOTPRequest = proto3.makeMessageType(
  "greyhole.myid.ResendSignUpOTPRequest",
  () => [
    { no: 1, name: "otp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "method", kind: "enum", T: proto3.getEnumType(ResendSignUpOTPRequest_ResendOTPMethod) },
  ],
);

/**
 * @generated from enum greyhole.myid.ResendSignUpOTPRequest.ResendOTPMethod
 */
export const ResendSignUpOTPRequest_ResendOTPMethod = proto3.makeEnum(
  "greyhole.myid.ResendSignUpOTPRequest.ResendOTPMethod",
  [
    {no: 0, name: "UNSPECIFIED"},
    {no: 1, name: "SMS"},
    {no: 2, name: "VOICE"},
    {no: 3, name: "EMAIL"},
  ],
);

/**
 * @generated from message greyhole.myid.ResendSignUpOTPReply
 */
export const ResendSignUpOTPReply = proto3.makeMessageType(
  "greyhole.myid.ResendSignUpOTPReply",
  () => [
    { no: 2, name: "confirm_otp", kind: "message", T: OTP },
  ],
);

/**
 * @generated from message greyhole.myid.ConfirmSignUpRequest
 */
export const ConfirmSignUpRequest = proto3.makeMessageType(
  "greyhole.myid.ConfirmSignUpRequest",
  () => [
    { no: 1, name: "otp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "otp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.ConfirmSignUpReply
 */
export const ConfirmSignUpReply = proto3.makeMessageType(
  "greyhole.myid.ConfirmSignUpReply",
  () => [
    { no: 1, name: "token_info", kind: "message", T: TokenInfo },
  ],
);

/**
 * @generated from message greyhole.myid.AddCredentialRequest
 */
export const AddCredentialRequest = proto3.makeMessageType(
  "greyhole.myid.AddCredentialRequest",
  () => [
    { no: 1, name: "my_id", kind: "message", T: SignUpV2Request_MyID, oneof: "credential" },
    { no: 2, name: "facebook", kind: "message", T: SignUpV2Request_Facebook, oneof: "credential" },
    { no: 3, name: "google", kind: "message", T: SignUpV2Request_Google, oneof: "credential" },
    { no: 4, name: "twitter", kind: "message", T: SignUpV2Request_Twitter, oneof: "credential" },
    { no: 5, name: "telegram", kind: "message", T: SignUpV2Request_Telegram, oneof: "credential" },
    { no: 6, name: "apple", kind: "message", T: SignUpV2Request_Apple, oneof: "credential" },
  ],
);

/**
 * deprecated
 *
 * @generated from message greyhole.myid.SignInRequest
 */
export const SignInRequest = proto3.makeMessageType(
  "greyhole.myid.SignInRequest",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.SignInV2Request
 */
export const SignInV2Request = proto3.makeMessageType(
  "greyhole.myid.SignInV2Request",
  () => [
    { no: 1, name: "my_id", kind: "message", T: SignInV2Request_MyID, oneof: "credential" },
    { no: 2, name: "facebook", kind: "message", T: SignInV2Request_Facebook, oneof: "credential" },
    { no: 5, name: "google", kind: "message", T: SignInV2Request_Google, oneof: "credential" },
    { no: 6, name: "twitter", kind: "message", T: SignInV2Request_Twitter, oneof: "credential" },
    { no: 7, name: "telegram", kind: "message", T: SignInV2Request_Telegram, oneof: "credential" },
    { no: 8, name: "apple", kind: "message", T: SignInV2Request_Apple, oneof: "credential" },
    { no: 3, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.SignInV2Request.MyID
 */
export const SignInV2Request_MyID = proto3.makeMessageType(
  "greyhole.myid.SignInV2Request.MyID",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SignInV2Request_MyID"},
);

/**
 * @generated from message greyhole.myid.SignInV2Request.Facebook
 */
export const SignInV2Request_Facebook = proto3.makeMessageType(
  "greyhole.myid.SignInV2Request.Facebook",
  () => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SignInV2Request_Facebook"},
);

/**
 * @generated from message greyhole.myid.SignInV2Request.Google
 */
export const SignInV2Request_Google = proto3.makeMessageType(
  "greyhole.myid.SignInV2Request.Google",
  () => [
    { no: 1, name: "credential", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SignInV2Request_Google"},
);

/**
 * @generated from message greyhole.myid.SignInV2Request.Twitter
 */
export const SignInV2Request_Twitter = proto3.makeMessageType(
  "greyhole.myid.SignInV2Request.Twitter",
  () => [
    { no: 1, name: "oauth1", kind: "message", T: SignInV2Request_Twitter_OAuth1, oneof: "version" },
    { no: 2, name: "oauth2", kind: "message", T: SignInV2Request_Twitter_OAuth2, oneof: "version" },
  ],
  {localName: "SignInV2Request_Twitter"},
);

/**
 * @generated from message greyhole.myid.SignInV2Request.Twitter.OAuth1
 */
export const SignInV2Request_Twitter_OAuth1 = proto3.makeMessageType(
  "greyhole.myid.SignInV2Request.Twitter.OAuth1",
  () => [
    { no: 1, name: "oauth_verifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "oauth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SignInV2Request_Twitter_OAuth1"},
);

/**
 * @generated from message greyhole.myid.SignInV2Request.Twitter.OAuth2
 */
export const SignInV2Request_Twitter_OAuth2 = proto3.makeMessageType(
  "greyhole.myid.SignInV2Request.Twitter.OAuth2",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "code_verifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SignInV2Request_Twitter_OAuth2"},
);

/**
 * @generated from message greyhole.myid.SignInV2Request.Telegram
 */
export const SignInV2Request_Telegram = proto3.makeMessageType(
  "greyhole.myid.SignInV2Request.Telegram",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "auth_date", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "photo_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SignInV2Request_Telegram"},
);

/**
 * @generated from message greyhole.myid.SignInV2Request.Apple
 */
export const SignInV2Request_Apple = proto3.makeMessageType(
  "greyhole.myid.SignInV2Request.Apple",
  () => [
    { no: 1, name: "identity_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SignInV2Request_Apple"},
);

/**
 * @generated from message greyhole.myid.SignInReply
 */
export const SignInReply = proto3.makeMessageType(
  "greyhole.myid.SignInReply",
  () => [
    { no: 3, name: "last_signed_in", kind: "message", T: Timestamp },
    { no: 1, name: "token_info", kind: "message", T: TokenInfo, oneof: "result" },
    { no: 2, name: "confirm_otp", kind: "message", T: OTP, oneof: "result" },
  ],
);

/**
 * @generated from message greyhole.myid.CheckCredentialsReply
 */
export const CheckCredentialsReply = proto3.makeMessageType(
  "greyhole.myid.CheckCredentialsReply",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "new_device", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message greyhole.myid.SignInPhoneRequest
 */
export const SignInPhoneRequest = proto3.makeMessageType(
  "greyhole.myid.SignInPhoneRequest",
  () => [
    { no: 1, name: "phone_number", kind: "message", T: PhoneNumber },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.SignInCryptoWalletRequest
 */
export const SignInCryptoWalletRequest = proto3.makeMessageType(
  "greyhole.myid.SignInCryptoWalletRequest",
  () => [
    { no: 1, name: "wallet_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "network_symbol", kind: "enum", T: proto3.getEnumType(NetworkSymbol) },
    { no: 3, name: "provider", kind: "enum", T: proto3.getEnumType(CryptoWalletProvider) },
    { no: 4, name: "public_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.SignInCryptoWalletReply
 */
export const SignInCryptoWalletReply = proto3.makeMessageType(
  "greyhole.myid.SignInCryptoWalletReply",
  () => [
    { no: 1, name: "challenge_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "nonce", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.SignInEmailRequest
 */
export const SignInEmailRequest = proto3.makeMessageType(
  "greyhole.myid.SignInEmailRequest",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.ConfirmCryptoWalletRequest
 */
export const ConfirmCryptoWalletRequest = proto3.makeMessageType(
  "greyhole.myid.ConfirmCryptoWalletRequest",
  () => [
    { no: 1, name: "challenge_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "signature", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.ConfirmCryptoWalletReply
 */
export const ConfirmCryptoWalletReply = proto3.makeMessageType(
  "greyhole.myid.ConfirmCryptoWalletReply",
  () => [
    { no: 1, name: "token_info", kind: "message", T: TokenInfo, oneof: "result" },
    { no: 2, name: "confirm_otp", kind: "message", T: OTP, oneof: "result" },
  ],
);

/**
 * @generated from message greyhole.myid.ResendSignInOTPRequest
 */
export const ResendSignInOTPRequest = proto3.makeMessageType(
  "greyhole.myid.ResendSignInOTPRequest",
  () => [
    { no: 1, name: "otp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.ResendSignInOTPReply
 */
export const ResendSignInOTPReply = proto3.makeMessageType(
  "greyhole.myid.ResendSignInOTPReply",
  () => [
    { no: 2, name: "confirm_otp", kind: "message", T: OTP },
  ],
);

/**
 * @generated from message greyhole.myid.ConfirmSignInRequest
 */
export const ConfirmSignInRequest = proto3.makeMessageType(
  "greyhole.myid.ConfirmSignInRequest",
  () => [
    { no: 1, name: "otp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "otp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.ConfirmSignInReply
 */
export const ConfirmSignInReply = proto3.makeMessageType(
  "greyhole.myid.ConfirmSignInReply",
  () => [
    { no: 1, name: "token_info", kind: "message", T: TokenInfo },
  ],
);

/**
 * @generated from message greyhole.myid.CreatePasswordRequest
 */
export const CreatePasswordRequest = proto3.makeMessageType(
  "greyhole.myid.CreatePasswordRequest",
  () => [
    { no: 1, name: "otp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "otp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "new_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "confirm_new_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.CreateAccessTokenRequest
 */
export const CreateAccessTokenRequest = proto3.makeMessageType(
  "greyhole.myid.CreateAccessTokenRequest",
  () => [
    { no: 1, name: "id_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.CreateAccessTokenReply
 */
export const CreateAccessTokenReply = proto3.makeMessageType(
  "greyhole.myid.CreateAccessTokenReply",
  () => [
    { no: 1, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "token_info", kind: "message", T: TokenInfo },
    { no: 3, name: "last_signed_in", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message greyhole.myid.MeReply
 */
export const MeReply = proto3.makeMessageType(
  "greyhole.myid.MeReply",
  () => [
    { no: 1, name: "user", kind: "message", T: UserInfo },
    { no: 2, name: "permissions", kind: "message", T: Permission, repeated: true },
    { no: 3, name: "module_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
  ],
);

/**
 * @generated from message greyhole.myid.ChangePasswordRequest
 */
export const ChangePasswordRequest = proto3.makeMessageType(
  "greyhole.myid.ChangePasswordRequest",
  () => [
    { no: 1, name: "current_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "new_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "confirm_new_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.UpdateMetadataRequest
 */
export const UpdateMetadataRequest = proto3.makeMessageType(
  "greyhole.myid.UpdateMetadataRequest",
  () => [
    { no: 1, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.UpdateEmailRequest
 */
export const UpdateEmailRequest = proto3.makeMessageType(
  "greyhole.myid.UpdateEmailRequest",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.UpdateEmailReply
 */
export const UpdateEmailReply = proto3.makeMessageType(
  "greyhole.myid.UpdateEmailReply",
  () => [
    { no: 1, name: "otp", kind: "message", T: OTP, oneof: "result" },
    { no: 2, name: "user", kind: "message", T: UserInfo, oneof: "result" },
  ],
);

/**
 * @generated from message greyhole.myid.VerifyEmailRequest
 */
export const VerifyEmailRequest = proto3.makeMessageType(
  "greyhole.myid.VerifyEmailRequest",
  () => [
    { no: 1, name: "otp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "otp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.VerifyEmailReply
 */
export const VerifyEmailReply = proto3.makeMessageType(
  "greyhole.myid.VerifyEmailReply",
  () => [
    { no: 1, name: "user", kind: "message", T: UserInfo },
  ],
);

/**
 * deprecated
 *
 * @generated from message greyhole.myid.UpdatePhoneNumberRequest
 */
export const UpdatePhoneNumberRequest = proto3.makeMessageType(
  "greyhole.myid.UpdatePhoneNumberRequest",
  () => [
    { no: 1, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.UpdatePhoneNumberV2Request
 */
export const UpdatePhoneNumberV2Request = proto3.makeMessageType(
  "greyhole.myid.UpdatePhoneNumberV2Request",
  () => [
    { no: 1, name: "phone_number", kind: "message", T: PhoneNumber },
    { no: 2, name: "method", kind: "enum", T: proto3.getEnumType(PhoneOTPMethod) },
  ],
);

/**
 * @generated from message greyhole.myid.UpdatePhoneNumberReply
 */
export const UpdatePhoneNumberReply = proto3.makeMessageType(
  "greyhole.myid.UpdatePhoneNumberReply",
  () => [
    { no: 1, name: "otp", kind: "message", T: OTP, oneof: "result" },
    { no: 2, name: "user", kind: "message", T: UserInfo, oneof: "result" },
  ],
);

/**
 * @generated from message greyhole.myid.VerifyPhoneNumberRequest
 */
export const VerifyPhoneNumberRequest = proto3.makeMessageType(
  "greyhole.myid.VerifyPhoneNumberRequest",
  () => [
    { no: 1, name: "otp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "otp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.VerifyPhoneNumberReply
 */
export const VerifyPhoneNumberReply = proto3.makeMessageType(
  "greyhole.myid.VerifyPhoneNumberReply",
  () => [
    { no: 1, name: "user", kind: "message", T: UserInfo },
  ],
);

/**
 * deprecated
 *
 * @generated from message greyhole.myid.ResetPasswordRequest
 */
export const ResetPasswordRequest = proto3.makeMessageType(
  "greyhole.myid.ResetPasswordRequest",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "by" },
    { no: 2, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "by" },
    { no: 3, name: "captcha", kind: "message", T: Captcha },
  ],
);

/**
 * @generated from message greyhole.myid.ResetPasswordV2Request
 */
export const ResetPasswordV2Request = proto3.makeMessageType(
  "greyhole.myid.ResetPasswordV2Request",
  () => [
    { no: 1, name: "captcha", kind: "message", T: Captcha },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "by" },
    { no: 3, name: "phone", kind: "message", T: ResetPasswordV2Request_Phone, oneof: "by" },
  ],
);

/**
 * @generated from message greyhole.myid.ResetPasswordV2Request.Phone
 */
export const ResetPasswordV2Request_Phone = proto3.makeMessageType(
  "greyhole.myid.ResetPasswordV2Request.Phone",
  () => [
    { no: 1, name: "phone_number", kind: "message", T: PhoneNumber },
    { no: 2, name: "method", kind: "enum", T: proto3.getEnumType(PhoneOTPMethod) },
  ],
  {localName: "ResetPasswordV2Request_Phone"},
);

/**
 * @generated from message greyhole.myid.ResetPasswordReply
 */
export const ResetPasswordReply = proto3.makeMessageType(
  "greyhole.myid.ResetPasswordReply",
  () => [
    { no: 1, name: "otp", kind: "message", T: OTP },
  ],
);

/**
 * @generated from message greyhole.myid.VerifyResetPasswordRequest
 */
export const VerifyResetPasswordRequest = proto3.makeMessageType(
  "greyhole.myid.VerifyResetPasswordRequest",
  () => [
    { no: 1, name: "otp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "otp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.SubmitResetPasswordRequest
 */
export const SubmitResetPasswordRequest = proto3.makeMessageType(
  "greyhole.myid.SubmitResetPasswordRequest",
  () => [
    { no: 1, name: "otp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "otp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "new_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "confirm_new_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.CheckCredentialRequest
 */
export const CheckCredentialRequest = proto3.makeMessageType(
  "greyhole.myid.CheckCredentialRequest",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "credential" },
    { no: 2, name: "google_credential", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "credential" },
    { no: 3, name: "facebook_token", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "credential" },
    { no: 4, name: "phone_number", kind: "message", T: PhoneNumber, oneof: "credential" },
    { no: 6, name: "telegram_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "credential" },
    { no: 7, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "credential" },
    { no: 8, name: "apple_identity_token", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "credential" },
  ],
);

/**
 * @generated from message greyhole.myid.UpdatePasswordRequest
 */
export const UpdatePasswordRequest = proto3.makeMessageType(
  "greyhole.myid.UpdatePasswordRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "new_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "confirm_new_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.UpdatePasswordReply
 */
export const UpdatePasswordReply = proto3.makeMessageType(
  "greyhole.myid.UpdatePasswordReply",
  [],
);

/**
 * @generated from message greyhole.myid.DeleteGoogleCredentialRequest
 */
export const DeleteGoogleCredentialRequest = proto3.makeMessageType(
  "greyhole.myid.DeleteGoogleCredentialRequest",
  () => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "delete_from_all_tenants", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message greyhole.myid.DeleteFacebookCredentialRequest
 */
export const DeleteFacebookCredentialRequest = proto3.makeMessageType(
  "greyhole.myid.DeleteFacebookCredentialRequest",
  () => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "facebook_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "delete_from_all_tenants", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message greyhole.myid.DeletePhoneCredentialRequest
 */
export const DeletePhoneCredentialRequest = proto3.makeMessageType(
  "greyhole.myid.DeletePhoneCredentialRequest",
  () => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "phone_number", kind: "message", T: PhoneNumber },
    { no: 3, name: "delete_from_all_tenants", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message greyhole.myid.DeleteTwitterCredentialRequest
 */
export const DeleteTwitterCredentialRequest = proto3.makeMessageType(
  "greyhole.myid.DeleteTwitterCredentialRequest",
  () => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "twitter_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "delete_from_all_tenants", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message greyhole.myid.DeleteTelegramCredentialRequest
 */
export const DeleteTelegramCredentialRequest = proto3.makeMessageType(
  "greyhole.myid.DeleteTelegramCredentialRequest",
  () => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "telegram_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "delete_from_all_tenants", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message greyhole.myid.DeleteCryptoWalletCredentialRequest
 */
export const DeleteCryptoWalletCredentialRequest = proto3.makeMessageType(
  "greyhole.myid.DeleteCryptoWalletCredentialRequest",
  () => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "delete_from_all_tenants", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "wallet_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "network_symbol", kind: "enum", T: proto3.getEnumType(NetworkSymbol) },
    { no: 5, name: "provider", kind: "enum", T: proto3.getEnumType(CryptoWalletProvider) },
  ],
);

/**
 * For public use
 *
 * @generated from message greyhole.myid.UserInfo
 */
export const UserInfo = proto3.makeMessageType(
  "greyhole.myid.UserInfo",
  () => [
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "roles", kind: "message", T: Role, repeated: true },
    { no: 7, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 8, name: "last_signed_in", kind: "message", T: Timestamp },
    { no: 9, name: "created_at", kind: "message", T: Timestamp },
    { no: 10, name: "updated_at", kind: "message", T: Timestamp },
    { no: 11, name: "credentials", kind: "message", T: Credential, repeated: true },
    { no: 12, name: "phone", kind: "message", T: PhoneNumber },
    { no: 13, name: "telegram", kind: "message", T: Telegram },
    { no: 14, name: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message greyhole.myid.TokenInfo
 */
export const TokenInfo = proto3.makeMessageType(
  "greyhole.myid.TokenInfo",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "id_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.Captcha
 */
export const Captcha = proto3.makeMessageType(
  "greyhole.myid.Captcha",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.CreateUserRequest
 */
export const CreateUserRequest = proto3.makeMessageType(
  "greyhole.myid.CreateUserRequest",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "phone_number", kind: "message", T: PhoneNumber },
    { no: 4, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "roles", kind: "message", T: Role, repeated: true },
    { no: 6, name: "send_mail_template_data", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 7, name: "type", kind: "enum", T: proto3.getEnumType(UserType) },
  ],
);

/**
 * @generated from message greyhole.myid.CreateUserReply
 */
export const CreateUserReply = proto3.makeMessageType(
  "greyhole.myid.CreateUserReply",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message greyhole.myid.ListUsersRequest
 */
export const ListUsersRequest = proto3.makeMessageType(
  "greyhole.myid.ListUsersRequest",
  () => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 3, name: "role_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 4, name: "statuses", kind: "enum", T: proto3.getEnumType(Status), repeated: true },
    { no: 5, name: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "cursor", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.ListUsersReply
 */
export const ListUsersReply = proto3.makeMessageType(
  "greyhole.myid.ListUsersReply",
  () => [
    { no: 1, name: "users", kind: "message", T: User, repeated: true },
    { no: 2, name: "next_cursor", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "has_more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message greyhole.myid.UpdateUserRequest
 */
export const UpdateUserRequest = proto3.makeMessageType(
  "greyhole.myid.UpdateUserRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "changes", kind: "message", T: UserChange, repeated: true },
  ],
);

/**
 * @generated from message greyhole.myid.UpdateUserReply
 */
export const UpdateUserReply = proto3.makeMessageType(
  "greyhole.myid.UpdateUserReply",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message greyhole.myid.LockUserRequest
 */
export const LockUserRequest = proto3.makeMessageType(
  "greyhole.myid.LockUserRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.LockUserReply
 */
export const LockUserReply = proto3.makeMessageType(
  "greyhole.myid.LockUserReply",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message greyhole.myid.LockUsersRequest
 */
export const LockUsersRequest = proto3.makeMessageType(
  "greyhole.myid.LockUsersRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.LockUsersReply
 */
export const LockUsersReply = proto3.makeMessageType(
  "greyhole.myid.LockUsersReply",
  () => [
    { no: 1, name: "failures", kind: "message", T: LockUsersReply_Failure, repeated: true },
  ],
);

/**
 * @generated from message greyhole.myid.LockUsersReply.Failure
 */
export const LockUsersReply_Failure = proto3.makeMessageType(
  "greyhole.myid.LockUsersReply.Failure",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "LockUsersReply_Failure"},
);

/**
 * @generated from message greyhole.myid.UnlockUserRequest
 */
export const UnlockUserRequest = proto3.makeMessageType(
  "greyhole.myid.UnlockUserRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.UnlockUserReply
 */
export const UnlockUserReply = proto3.makeMessageType(
  "greyhole.myid.UnlockUserReply",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message greyhole.myid.BanUserRequest
 */
export const BanUserRequest = proto3.makeMessageType(
  "greyhole.myid.BanUserRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.BanUserReply
 */
export const BanUserReply = proto3.makeMessageType(
  "greyhole.myid.BanUserReply",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message greyhole.myid.BanUsersRequest
 */
export const BanUsersRequest = proto3.makeMessageType(
  "greyhole.myid.BanUsersRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.BanUsersReply
 */
export const BanUsersReply = proto3.makeMessageType(
  "greyhole.myid.BanUsersReply",
  () => [
    { no: 1, name: "failures", kind: "message", T: BanUsersReply_Failure, repeated: true },
  ],
);

/**
 * @generated from message greyhole.myid.BanUsersReply.Failure
 */
export const BanUsersReply_Failure = proto3.makeMessageType(
  "greyhole.myid.BanUsersReply.Failure",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "BanUsersReply_Failure"},
);

/**
 * @generated from message greyhole.myid.UnbanUserRequest
 */
export const UnbanUserRequest = proto3.makeMessageType(
  "greyhole.myid.UnbanUserRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.UnbanUserReply
 */
export const UnbanUserReply = proto3.makeMessageType(
  "greyhole.myid.UnbanUserReply",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message greyhole.myid.GetUserRequest
 */
export const GetUserRequest = proto3.makeMessageType(
  "greyhole.myid.GetUserRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message greyhole.myid.GetUserReply
 */
export const GetUserReply = proto3.makeMessageType(
  "greyhole.myid.GetUserReply",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message greyhole.myid.ResendCreatePasswordOTPRequest
 */
export const ResendCreatePasswordOTPRequest = proto3.makeMessageType(
  "greyhole.myid.ResendCreatePasswordOTPRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "send_mail_template_data", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message greyhole.myid.ResendCreatePasswordOTPReply
 */
export const ResendCreatePasswordOTPReply = proto3.makeMessageType(
  "greyhole.myid.ResendCreatePasswordOTPReply",
  [],
);

/**
 * @generated from message greyhole.myid.GetUsersRequest
 */
export const GetUsersRequest = proto3.makeMessageType(
  "greyhole.myid.GetUsersRequest",
  () => [
    { no: 1, name: "user_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
  ],
);

/**
 * @generated from message greyhole.myid.GetUsersReply
 */
export const GetUsersReply = proto3.makeMessageType(
  "greyhole.myid.GetUsersReply",
  () => [
    { no: 1, name: "users", kind: "message", T: User, repeated: true },
  ],
);

/**
 * deprecated
 *
 * @generated from message greyhole.myid.GetUsersByUsernameRequest
 */
export const GetUsersByUsernameRequest = proto3.makeMessageType(
  "greyhole.myid.GetUsersByUsernameRequest",
  () => [
    { no: 1, name: "usernames", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "tenant_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * deprecated
 *
 * @generated from message greyhole.myid.GetUsersByUsernameReply
 */
export const GetUsersByUsernameReply = proto3.makeMessageType(
  "greyhole.myid.GetUsersByUsernameReply",
  () => [
    { no: 1, name: "users", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: User} },
  ],
);

/**
 * @generated from message greyhole.myid.GetUserByUsernameRequest
 */
export const GetUserByUsernameRequest = proto3.makeMessageType(
  "greyhole.myid.GetUserByUsernameRequest",
  () => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.GetUserByUsernameReply
 */
export const GetUserByUsernameReply = proto3.makeMessageType(
  "greyhole.myid.GetUserByUsernameReply",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message greyhole.myid.User
 */
export const User = proto3.makeMessageType(
  "greyhole.myid.User",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "roles", kind: "message", T: Role, repeated: true },
    { no: 7, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 9, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "last_signed_in", kind: "message", T: Timestamp },
    { no: 12, name: "updated_at", kind: "message", T: Timestamp },
    { no: 14, name: "credentials", kind: "message", T: Credential, repeated: true },
    { no: 15, name: "phone", kind: "message", T: PhoneNumber },
    { no: 16, name: "telegram", kind: "message", T: Telegram },
    { no: 17, name: "type", kind: "enum", T: proto3.getEnumType(UserType) },
    { no: 18, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.Telegram
 */
export const Telegram = proto3.makeMessageType(
  "greyhole.myid.Telegram",
  () => [
    { no: 1, name: "chat_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.PhoneNumber
 */
export const PhoneNumber = proto3.makeMessageType(
  "greyhole.myid.PhoneNumber",
  () => [
    { no: 1, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "national_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.Role
 */
export const Role = proto3.makeMessageType(
  "greyhole.myid.Role",
  () => [
    { no: 1, name: "group_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "role_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message greyhole.myid.Roles
 */
export const Roles = proto3.makeMessageType(
  "greyhole.myid.Roles",
  () => [
    { no: 1, name: "roles", kind: "message", T: Role, repeated: true },
  ],
);

/**
 * @generated from message greyhole.myid.UserChange
 */
export const UserChange = proto3.makeMessageType(
  "greyhole.myid.UserChange",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 2, name: "phone_number", kind: "message", T: PhoneNumber, oneof: "field" },
    { no: 3, name: "roles", kind: "message", T: Roles, oneof: "field" },
    { no: 4, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
  ],
);

/**
 * @generated from message greyhole.myid.Permission
 */
export const Permission = proto3.makeMessageType(
  "greyhole.myid.Permission",
  () => [
    { no: 1, name: "actions", kind: "message", T: Action, repeated: true },
    { no: 2, name: "resources", kind: "message", T: Resource, repeated: true },
  ],
);

/**
 * @generated from message greyhole.myid.Resource
 */
export const Resource = proto3.makeMessageType(
  "greyhole.myid.Resource",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "parent_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message greyhole.myid.Action
 */
export const Action = proto3.makeMessageType(
  "greyhole.myid.Action",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "resource", kind: "message", T: Resource },
  ],
);

/**
 * @generated from message greyhole.myid.ResendResetPasswordOTPRequest
 */
export const ResendResetPasswordOTPRequest = proto3.makeMessageType(
  "greyhole.myid.ResendResetPasswordOTPRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message greyhole.myid.ResendResetPasswordOTPReply
 */
export const ResendResetPasswordOTPReply = proto3.makeMessageType(
  "greyhole.myid.ResendResetPasswordOTPReply",
  () => [
    { no: 1, name: "otp_info", kind: "message", T: OTP_Info },
  ],
);

/**
 * @generated from message greyhole.myid.Credential
 */
export const Credential = proto3.makeMessageType(
  "greyhole.myid.Credential",
  () => [
    { no: 1, name: "my_id", kind: "message", T: Credential_MyID, oneof: "method" },
    { no: 2, name: "facebook", kind: "message", T: Credential_Facebook, oneof: "method" },
    { no: 3, name: "google", kind: "message", T: Credential_Google, oneof: "method" },
    { no: 4, name: "phone", kind: "message", T: Credential_PhoneCredential, oneof: "method" },
    { no: 5, name: "twitter", kind: "message", T: Credential_Twitter, oneof: "method" },
    { no: 6, name: "telegram", kind: "message", T: Credential_Telegram, oneof: "method" },
    { no: 7, name: "crypto_wallet", kind: "message", T: Credential_CryptoWallet, oneof: "method" },
    { no: 8, name: "email", kind: "message", T: Credential_Email, oneof: "method" },
    { no: 9, name: "apple", kind: "message", T: Credential_Apple, oneof: "method" },
  ],
);

/**
 * @generated from message greyhole.myid.Credential.MyID
 */
export const Credential_MyID = proto3.makeMessageType(
  "greyhole.myid.Credential.MyID",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Credential_MyID"},
);

/**
 * @generated from message greyhole.myid.Credential.Facebook
 */
export const Credential_Facebook = proto3.makeMessageType(
  "greyhole.myid.Credential.Facebook",
  () => [
    { no: 1, name: "fb_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Credential_Facebook"},
);

/**
 * @generated from message greyhole.myid.Credential.Google
 */
export const Credential_Google = proto3.makeMessageType(
  "greyhole.myid.Credential.Google",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Credential_Google"},
);

/**
 * @generated from message greyhole.myid.Credential.PhoneCredential
 */
export const Credential_PhoneCredential = proto3.makeMessageType(
  "greyhole.myid.Credential.PhoneCredential",
  () => [
    { no: 1, name: "phone_number", kind: "message", T: PhoneNumber },
  ],
  {localName: "Credential_PhoneCredential"},
);

/**
 * @generated from message greyhole.myid.Credential.Twitter
 */
export const Credential_Twitter = proto3.makeMessageType(
  "greyhole.myid.Credential.Twitter",
  () => [
    { no: 1, name: "twitter_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Credential_Twitter"},
);

/**
 * @generated from message greyhole.myid.Credential.Telegram
 */
export const Credential_Telegram = proto3.makeMessageType(
  "greyhole.myid.Credential.Telegram",
  () => [
    { no: 1, name: "telegram_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Credential_Telegram"},
);

/**
 * @generated from message greyhole.myid.Credential.CryptoWallet
 */
export const Credential_CryptoWallet = proto3.makeMessageType(
  "greyhole.myid.Credential.CryptoWallet",
  () => [
    { no: 1, name: "wallet_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "network_symbol", kind: "enum", T: proto3.getEnumType(NetworkSymbol) },
  ],
  {localName: "Credential_CryptoWallet"},
);

/**
 * @generated from message greyhole.myid.Credential.Email
 */
export const Credential_Email = proto3.makeMessageType(
  "greyhole.myid.Credential.Email",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Credential_Email"},
);

/**
 * @generated from message greyhole.myid.Credential.Apple
 */
export const Credential_Apple = proto3.makeMessageType(
  "greyhole.myid.Credential.Apple",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Credential_Apple"},
);

/**
 * @generated from message greyhole.myid.OTP
 */
export const OTP = proto3.makeMessageType(
  "greyhole.myid.OTP",
  () => [
    { no: 1, name: "waiting", kind: "scalar", T: 4 /* ScalarType.UINT64 */, oneof: "result" },
    { no: 2, name: "success", kind: "message", T: OTP_Info, oneof: "result" },
  ],
);

/**
 * @generated from message greyhole.myid.OTP.Info
 */
export const OTP_Info = proto3.makeMessageType(
  "greyhole.myid.OTP.Info",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "recipient", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "expiry", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
  {localName: "OTP_Info"},
);

/**
 * @generated from message greyhole.myid.UpdateUserContactRequest
 */
export const UpdateUserContactRequest = proto3.makeMessageType(
  "greyhole.myid.UpdateUserContactRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "phone_number", kind: "message", T: PhoneNumber, oneof: "contact" },
    { no: 3, name: "telegram", kind: "message", T: Telegram, oneof: "contact" },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "contact" },
  ],
);

/**
 * @generated from message greyhole.myid.UpdateUserContactReply
 */
export const UpdateUserContactReply = proto3.makeMessageType(
  "greyhole.myid.UpdateUserContactReply",
  [],
);

/**
 * @generated from message greyhole.myid.ListStatusLogsRequest
 */
export const ListStatusLogsRequest = proto3.makeMessageType(
  "greyhole.myid.ListStatusLogsRequest",
  () => [
    { no: 1, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "cursor", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message greyhole.myid.ListStatusLogsReply
 */
export const ListStatusLogsReply = proto3.makeMessageType(
  "greyhole.myid.ListStatusLogsReply",
  () => [
    { no: 1, name: "logs", kind: "message", T: StatusLog, repeated: true },
    { no: 2, name: "next_cursor", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "has_more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message greyhole.myid.StatusLog
 */
export const StatusLog = proto3.makeMessageType(
  "greyhole.myid.StatusLog",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "log_type", kind: "enum", T: proto3.getEnumType(StatusLogType) },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "handled_by", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message greyhole.myid.ChangePlayerPasswordRequest
 */
export const ChangePlayerPasswordRequest = proto3.makeMessageType(
  "greyhole.myid.ChangePlayerPasswordRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "new_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message greyhole.myid.ChangePlayerPasswordReply
 */
export const ChangePlayerPasswordReply = proto3.makeMessageType(
  "greyhole.myid.ChangePlayerPasswordReply",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "new_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

